// extracted by mini-css-extract-plugin
export var base = "heading-module--base--98a40";
export var primary = "heading-module--primary--b5691";
export var quarternary = "heading-module--quarternary--9b1b5";
export var secondary = "heading-module--secondary--b54c9";
export var tertiary = "heading-module--tertiary--b7a99";